<template>
  <NuxtLayout>
    <div class="app_container w">
      <EntrancetestHead />
      <div class="entrace-body">
        <div class="history-entry">
          <el-button class="history-entry-link" type="primary" link @click="openHistoryDialog">
            查看历史诊断记录
          </el-button>
        </div>
        <template v-if="subjectList.length && selectedSubjectId">
          <p class="body-desc">{{ introText }}</p>

          <div class="section-head">
            <el-divider direction="vertical" />
            <span class="section-title">选择诊断学科</span>
          </div>
          <div class="subject-tabs">
            <span
              v-for="item in subjectList"
              :key="item.id"
              class="search_type_item"
              :class="{ active: String(selectedSubjectId) === String(item.id) }"
              @click="handleSelectSubject(item)"
            >{{ item.subjectName }}</span>
          </div>

          <div class="section-head survey-head">
            <el-divider direction="vertical" />
            <span class="section-title">我的申硕学情档案</span>
            <span class="section-tip">信息仅用于助教定制学习计划</span>
          </div>
          <el-divider />
          <el-form
            class="body-form"
            ref="formRef"
            :rules="formRules"
            size="large"
            label-position="top"
            :model="formData.form"
          >
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="formData.form.userName" clearable autocomplete="off" />
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input
                v-model="formData.form.phone"
                autocomplete="off"
                :maxlength="isMaskedPhone(formData.form.phone) ? 20 : 11"
                @input="onSurveyPhoneInput"
                :readonly="isLoggedIn"
                clearable
              />
              <div v-if="verifiedPhones.length && !isLoggedIn" class="verified-phone-list">
                <span class="verified-phone-label">已验证号码：</span>
                <button
                  v-for="p in verifiedPhones"
                  :key="p"
                  type="button"
                  class="verified-phone-chip"
                  @click="selectVerifiedPhone(p)"
                >
                  {{ maskPhoneDisplay(p) }}
                </button>
              </div>
              <p v-if="!isLoggedIn && !needSmsVerify && /^1\d{10}$/.test(surveyPhone)" class="verify-free-tip">
                该手机号已验证，无需短信验证码
              </p>
            </el-form-item>
            <el-form-item v-if="needSmsVerify" label="验证码" prop="verificationCode">
              <el-input
                v-model="formData.form.verificationCode"
                placeholder="请输入短信验证码"
                autocomplete="off"
                maxlength="6"
              >
                <template #suffix>
                  <el-button
                    class="sms_btn"
                    type="primary"
                    link
                    :disabled="smsDisabled"
                    @click="getCode('survey')"
                  >
                    {{ smsTxt }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="formData.form.sex">
                <el-radio class="info-radio" :label="1">男</el-radio>
                <el-radio class="info-radio" :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="目标报考院校"
              prop="targetCollege"
              class="college-form-item"
              :class="{ 'is-college-open': collegePanelOpen }"
            >
              <div ref="collegePickerRef" class="college-picker">
                <el-input
                  v-model="formData.form.targetCollege"
                  clearable
                  placeholder="请选择或输入院校（可搜索/手输）"
                  autocomplete="off"
                  @focus="openCollegePanel"
                  @input="onCollegeInput"
                />
                <ul v-show="collegePanelOpen" class="college-picker__list">
                  <li
                    v-for="item in filteredColleges"
                    :key="item"
                    class="college-picker__item"
                    @mousedown.prevent="selectCollege(item)"
                  >
                    {{ item }}
                  </li>
                  <li v-if="!filteredColleges.length" class="college-picker__empty">
                    无匹配院校，可直接输入
                  </li>
                </ul>
              </div>
            </el-form-item>
            <el-form-item label="本科毕业时间" prop="undergraduateGradTime">
              <el-date-picker
                v-model="formData.form.undergraduateGradTime"
                type="month"
                placeholder="请选择年月"
                format="YYYY-MM"
                value-format="YYYY-MM"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item label="本科所学专业" prop="undergraduateMajor">
              <el-input
                v-model="formData.form.undergraduateMajor"
                placeholder="请输入本科专业"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item label="英语四、六级等情况" prop="cetLevel">
              <el-radio-group v-model="formData.form.cetLevel">
                <el-radio
                  v-for="item in cetLevelOptions"
                  :key="item"
                  class="info-radio"
                  :label="item"
                >{{ item }}</el-radio>
              </el-radio-group>
              <el-input
                v-if="formData.form.cetLevel === '其他'"
                v-model="cetLevelOtherText"
                class="other-input"
                placeholder="请输入您的英语四、六级情况（必填）"
                maxlength="50"
                clearable
                @blur="formRef?.validateField('cetLevel')"
              />
            </el-form-item>
            <el-form-item label="年龄段" prop="ageGroup">
              <el-radio-group v-model="formData.form.ageGroup">
                <el-radio class="info-radio" :label="1">18-20</el-radio>
                <el-radio class="info-radio" :label="2">21-30</el-radio>
                <el-radio class="info-radio" :label="3">31-40</el-radio>
                <el-radio class="info-radio" :label="4">41-50</el-radio>
                <el-radio class="info-radio" :label="5">50以上</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="现从事职业" prop="currentJob">
              <el-input
                v-model="formData.form.currentJob"
                placeholder="选填"
                autocomplete="off"
              />
            </el-form-item>
            <el-form-item label="您目前最担心或最想解决的备考难题？" prop="prepDifficulties">
              <el-checkbox-group v-model="formData.form.prepDifficulties">
                <el-checkbox
                  v-for="item in prepDifficultyOptions"
                  :key="item"
                  :label="item"
                >{{ item }}</el-checkbox>
              </el-checkbox-group>
              <el-input
                v-if="formData.form.prepDifficulties.includes('其他')"
                v-model="prepDifficultyOtherText"
                class="other-input"
                placeholder="请输入您担心或想解决的备考难题（选填）"
                maxlength="50"
                clearable
              />
            </el-form-item>
            <el-form-item label="您计划每天投入的备考时长？" prop="prepDuration">
              <el-radio-group v-model="formData.form.prepDuration">
                <el-radio
                  v-for="item in prepDurationOptions"
                  :key="item"
                  class="info-radio"
                  :label="item"
                >{{ item }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <div class="submit-row">
                <el-button type="primary" :disabled="!selectedSubjectId" @click="submitForm">
                  提交并前往考试
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </template>
        <el-empty v-else description="暂无可测学科，敬请期待" />
      </div>
    </div>

    <el-dialog
      v-model="historyVisible"
      title="历史诊断记录"
      width="680px"
      class="history-dialog"
      destroy-on-close
      @opened="onHistoryOpened"
      @closed="onHistoryClosed"
    >
      <!-- 游客：当前手机号无有效 verifyToken 时需短信；可点选已验证号码免码 -->
      <div v-if="!historyQueried && !isLoggedIn && historyNeedSmsVerify" class="history-verify">
        <p class="history-verify-tip">
          请输入新手机号，或点选下方已验证号码查看其历史记录（不会清除其它号的验证与记录）
        </p>
        <el-form
          class="history-verify-form"
          label-position="top"
          :model="historyForm"
          @submit.prevent
        >
          <el-form-item label="手机号" required>
            <el-input
              v-model="historyForm.phone"
              size="large"
              maxlength="11"
              clearable
              placeholder="请输入11位手机号"
              autocomplete="off"
              @input="bumpPhoneVerifyTick"
            />
            <div v-if="verifiedPhones.length" class="verified-phone-list">
              <span class="verified-phone-label">已验证号码：</span>
              <button
                v-for="p in verifiedPhones"
                :key="p"
                type="button"
                class="verified-phone-chip"
                @click="selectHistoryVerifiedPhone(p)"
              >
                {{ maskPhoneDisplay(p) }}
              </button>
            </div>
          </el-form-item>
          <el-form-item v-if="historyNeedSmsVerify" label="短信验证码" required>
            <div class="history-code-row">
              <el-input
                v-model="historyForm.verificationCode"
                size="large"
                maxlength="6"
                clearable
                placeholder="请输入验证码"
                autocomplete="off"
              />
              <el-button
                class="history-sms-btn"
                size="large"
                :disabled="historySmsDisabled"
                @click="getCode('history')"
              >
                {{ historySmsTxt }}
              </el-button>
            </div>
          </el-form-item>
          <el-button
            class="history-query-btn"
            type="primary"
            size="large"
            :loading="historyLoading"
            @click="queryHistory()"
          >
            查询记录
          </el-button>
        </el-form>
      </div>

      <!-- 已登录 / 游客已有 verifyToken：直接加载 -->
      <div
        v-else-if="!historyQueried && (isLoggedIn || !historyNeedSmsVerify)"
        v-loading="historyLoading"
        class="history-result"
      >
        <el-empty
          v-if="!historyLoading"
          :description="historyErrorMsg || '暂无诊断记录'"
        >
          <el-button
            v-if="isLoggedIn"
            type="primary"
            @click="queryHistory({ preferLogin: true })"
          >
            重新加载
          </el-button>
          <el-button v-else type="primary" @click="resetHistoryQuery">
            查询其他手机号
          </el-button>
        </el-empty>
      </div>

      <!-- 记录列表 -->
      <div v-else v-loading="historyLoading" class="history-result">
        <div class="history-result-bar">
          <span class="history-result-count">
            共 {{ historyPagination.totalCount }} 条记录
            <template v-if="historyForm.phone">（{{ maskPhoneDisplay(historyForm.phone) }}）</template>
          </span>
          <el-button
            v-if="isLoggedIn"
            type="primary"
            link
            @click="refreshHistoryLogin"
          >
            刷新
          </el-button>
          <el-button v-else type="primary" link @click="resetHistoryQuery">
            查询其他手机号
          </el-button>
        </div>
        <el-empty v-if="!historyList.length" description="暂无诊断记录" />
        <div v-else class="history-list">
          <div v-for="item in historyList" :key="item.recordId" class="history-item">
            <div class="history-main">
              <div class="history-title">
                {{ item.subjectName || "申硕基点诊断" }}
                <span v-if="item.scoreLevel" class="history-level">{{ item.scoreLevel }}</span>
              </div>
              <div class="history-meta">
                <span v-if="item.userName">{{ item.userName }}</span>
                <span v-if="item.phone">{{ item.phone }}</span>
                <span v-if="item.totalScore != null">得分 {{ item.totalScore }}</span>
                <span>{{ formatHistoryTime(item.gmtCreate) }}</span>
              </div>
            </div>
            <el-button
              type="primary"
              :disabled="item.ready === false"
              @click="goHistoryReport(item)"
            >
              {{ item.ready === false ? "生成中" : "查看报告" }}
            </el-button>
          </div>
        </div>
        <div v-if="historyPagination.totalCount > historyPagination.pageSize" class="history-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="historyPagination.pageCurrent"
            :page-size="historyPagination.pageSize"
            :total="historyPagination.totalCount"
            @current-change="onHistoryPageChange"
          />
        </div>
      </div>
    </el-dialog>

    <AliyunCaptchaDialog
      v-model="captchaVisible"
      :captcha-id="captchaConfig.captchaId"
      @success="handleCaptchaSuccess"
      @error="handleCaptchaError"
      @close="handleCaptchaClose"
    />
  </NuxtLayout>
</template>

<script setup>
import { computed, nextTick, onActivated, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import {
  diagnosisSubjectList,
  diagnosisEntranceView,
  diagnosisUserSave,
  diagnosisReportHistory,
  diagnosisCollegeList,
} from "@/api/diagnosis";
import { getMsg, getAppKeyInfo } from "@/api/user";
import cookie from "@/utils/cookies";
import config from "@/config";
import EntrancetestHead from "./EntrancetestHead.vue";
import {
  CET_LEVEL_OPTIONS,
  PREP_DIFFICULTY_OPTIONS,
  PREP_DURATION_OPTIONS,
} from "@/constants/diagnosisSurvey";
import AliyunCaptchaDialog from "@/components/login/AliyunCaptchaDialog.vue";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/stores/user";
import {
  clearDiagnosisVerifyToken,
  getDiagnosisVerifyToken,
  getLastDiagnosisVerifiedPhone,
  getRememberedDiagnosisPhone,
  hasValidDiagnosisVerifyToken,
  isDiagnosisVerifyExpiredMsg,
  listVerifiedDiagnosisPhones,
  rememberDiagnosisPhone,
  saveDiagnosisVerifyToken,
  saveDiagnosisProfile,
  getDiagnosisProfile,
  saveDiagnosisUserProfile,
  getDiagnosisUserProfile,
} from "@/utils/diagnosisVerifyToken";

const HISTORY_CACHE_KEY = "diagnosis_report_history_cache";
const HISTORY_MAP_KEY = "diagnosis_report_history_map";
const HISTORY_CACHE_TTL = 30 * 60 * 1000;
const SMS_COOLDOWN_KEY = "diagnosis_sms_cooldown";
const SMS_COOLDOWN_SEC = 60;

const cookieData = cookie.getShop();
const formRef = ref(null);
const router = useRouter();
const userStore = useUserStore();

const subjectList = ref([]);
const selectedSubjectId = ref(null);

/** 首页固定引导文案（按设计稿） */
const introText = `同学，你好呀👋 欢迎开启同等学力申硕备考之旅。
请放轻松，如实作答。完成题目后，系统将帮你把“模糊的感受”转化为“清晰的定位”，为你提供个性化备考方案。现在，让我们开始吧。你的答案，就是你的方向。`;

/**
 * 与顶栏头像同一套登录态（pinia token），避免「cookie 残留失效 token、顶栏已显示登录/注册」
 * 时仍隐藏短信验证码，导致二次诊断提交报「请输入手机号和短信验证码」。
 */
const isLoggedIn = computed(() => !!userStore.token);

/** 接口判定需短信时强制展示验证码（会话失效 / verifyToken 失效） */
const forceSmsVerify = ref(false);
/** 手机号变更时触发重新计算 needSmsVerify（读 localStorage） */
const phoneVerifyTick = ref(0);

/** 用户中心返回的脱敏手机号，如 130****3101 */
const isMaskedPhone = (phone) => /\*/.test(String(phone || ""));

const smsTxt = ref("获取验证码");
const smsDisabled = ref(false);
const historySmsTxt = ref("获取验证码");
const historySmsDisabled = ref(false);
const captchaVisible = ref(false);
const captchaConfig = reactive({
  captchaId: "",
});
let captchaValidate = null;
/** survey | history */
const smsScene = ref("survey");

const historyVisible = ref(false);
const historyLoading = ref(false);
const historyQueried = ref(false);
const historyList = ref([]);
const historyErrorMsg = ref("");
const historyPagination = reactive({
  pageCurrent: 1,
  pageSize: 10,
  totalCount: 0,
  totalPage: 0,
});
const cooperativeColleges = ref([]);
const cetLevelOptions = CET_LEVEL_OPTIONS;
const prepDifficultyOptions = PREP_DIFFICULTY_OPTIONS;
const prepDurationOptions = PREP_DURATION_OPTIONS;
/** 四六级/备考难题选择「其他」时的自定义输入内容 */
const cetLevelOtherText = ref("");
const prepDifficultyOtherText = ref("");

/** 标准选项（不含「其他」）：回显时判断是否为自定义内容用 */
const STANDARD_CET_LEVELS = CET_LEVEL_OPTIONS.filter((o) => o !== "其他");
const STANDARD_PREP_DIFFICULTIES = PREP_DIFFICULTY_OPTIONS.filter((o) => o !== "其他");
const collegePanelOpen = ref(false);
const collegePickerRef = ref(null);

const filteredColleges = computed(() => {
  const q = String(formData.form.targetCollege || "").trim().toLowerCase();
  const list = cooperativeColleges.value || [];
  if (!q) {
    return list;
  }
  return list.filter((name) => name.toLowerCase().includes(q));
});

const openCollegePanel = () => {
  collegePanelOpen.value = true;
};

const onCollegeInput = () => {
  collegePanelOpen.value = true;
};

const selectCollege = (name) => {
  formData.form.targetCollege = name;
  collegePanelOpen.value = false;
};

const onCollegeDocClick = (e) => {
  const root = collegePickerRef.value;
  if (!root || !collegePanelOpen.value) {
    return;
  }
  if (!root.contains(e.target)) {
    collegePanelOpen.value = false;
  }
};
const historyForm = reactive({
  phone: "",
  verificationCode: "",
});

const validatePhone = async (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入电话"));
  } else if (isLoggedIn.value && isMaskedPhone(value)) {
    // 已登录预填脱敏号：前端放行，后端用账号真实手机号落库
    callback();
  } else if (!/^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(value)) {
    callback(new Error("请输入正确的电话号"));
  } else {
    callback();
  }
};

const formData = reactive({
  form: {
    userName: "",
    phone: "",
    verificationCode: "",
    sex: null,
    targetCollege: "",
    undergraduateGradTime: "",
    undergraduateMajor: "",
    cetLevel: "",
    ageGroup: null,
    currentJob: "",
    prepDifficulties: [],
    prepDuration: "",
  },
  map: {
    paperId: null,
    title: "",
    description: "",
  },
});

/** 参与本地保存/回显的档案字段（不含 phone、verificationCode） */
const PROFILE_FIELDS = [
  "userName", "sex", "ageGroup", "targetCollege",
  "undergraduateGradTime", "undergraduateMajor", "cetLevel",
  "currentJob", "prepDifficulties", "prepDuration",
];

const collectProfileForm = () => {
  const data = {};
  PROFILE_FIELDS.forEach((k) => { data[k] = formData.form[k]; });
  return data;
};

/** 回显档案：旧数据缺的字段跳过（保持表单现状），prepDifficulties 兜底数组 */
const applyProfileToForm = (profile) => {
  if (!profile) return;
  PROFILE_FIELDS.forEach((k) => {
    const v = profile[k];
    if (v === undefined || v === null) return;
    const isEmpty = k === "prepDifficulties"
      ? !formData.form[k]?.length
      : (formData.form[k] === "" || formData.form[k] === null || formData.form[k] === undefined);
    if (!isEmpty) return;   // 用户已填的字段不动
    // 四六级
    if (k === "cetLevel") {
      if (STANDARD_CET_LEVELS.includes(v)) {
        formData.form.cetLevel = v;
        cetLevelOtherText.value = "";
      } else if (v === "其他") {
        // 历史脏数据：只有「其他」没有内容
        formData.form.cetLevel = "其他";
        cetLevelOtherText.value = "";
      } else {
        // 非标准值 → 判定为自定义内容，勾选「其他」并回显输入框
        formData.form.cetLevel = "其他";
        cetLevelOtherText.value = String(v);
      }
      return;
    }
    // 备考难题
    if (k === "prepDifficulties") {
      const arr = Array.isArray(v) ? v : [];
      const stdVals = arr.filter((x) => STANDARD_PREP_DIFFICULTIES.includes(x));
      const custom = arr.filter((x) => !STANDARD_PREP_DIFFICULTIES.includes(x) && x !== "其他");
      const next = [...stdVals];
      if (arr.includes("其他") || custom.length) next.push("其他");
      formData.form.prepDifficulties = next;
      prepDifficultyOtherText.value = custom[0] || "";
      return;
    }

    formData.form[k] = Array.isArray(formData.form[k]) ? (Array.isArray(v) ? v : []) : v;
    // formData.form[k] = k === "prepDifficulties" ? (Array.isArray(v) ? v : []) : v;
  });
};

/** 档案字段初始默认值（取自 formData 初始状态，重置表单用） */
const PROFILE_DEFAULTS = PROFILE_FIELDS.reduce((acc, k) => {
  acc[k] = Array.isArray(formData.form[k]) ? [] : formData.form[k];
  return acc;
}, {});

/** 当前表单档案回显自哪个手机号；空串表示表单内容不是回显来的 */
let echoedProfilePhone = "";

/** 清空回显出来的档案字段（只清表单显示，不动 localStorage 里的档案） */
const resetProfileForm = () => {
  PROFILE_FIELDS.forEach((k) => {
    formData.form[k] = k === "prepDifficulties" ? [] : PROFILE_DEFAULTS[k];
  });
  cetLevelOtherText.value = "";
  prepDifficultyOtherText.value = "";
};

const surveyPhone = computed(() => String(formData.form.phone || "").trim());
const historyPhone = computed(() => String(historyForm.phone || "").trim());

/**
 * 调查表是否需要填短信验证码：
 * 已登录默认否；游客看本地是否有该手机号未过期的 verifyToken。
 */
const needSmsVerify = computed(() => {
  phoneVerifyTick.value;
  if (isLoggedIn.value) {
    return forceSmsVerify.value;
  }
  if (forceSmsVerify.value) {
    return true;
  }
  return !hasValidDiagnosisVerifyToken(surveyPhone.value);
});

/** 历史查询游客是否还需验证码 */
const historyNeedSmsVerify = computed(() => {
  phoneVerifyTick.value;
  if (isLoggedIn.value) {
    return false;
  }
  return !hasValidDiagnosisVerifyToken(historyPhone.value);
});

/** 同环境已验证且未过期的手机号（可点选） */
const verifiedPhones = computed(() => {
  phoneVerifyTick.value;
  return listVerifiedDiagnosisPhones();
});

const bumpPhoneVerifyTick = () => {
  phoneVerifyTick.value += 1;
  if (forceSmsVerify.value && hasValidDiagnosisVerifyToken(surveyPhone.value)) {
    forceSmsVerify.value = false;
  }
};

const onSurveyPhoneInput = () => {
  // 输入到完整 11 位且本地有凭证 → 自动免验
  if (hasValidDiagnosisVerifyToken(surveyPhone.value)) {
    forceSmsVerify.value = false;
  }
  bumpPhoneVerifyTick();
  clearSurveyFormValidate();
};

const selectVerifiedPhone = (phone) => {
  formData.form.phone = phone;
  forceSmsVerify.value = false;
  formData.form.verificationCode = "";
  rememberDiagnosisPhone(phone);
  bumpPhoneVerifyTick();
  clearSurveyFormValidate();
};

const selectHistoryVerifiedPhone = (phone) => {
  historyForm.phone = phone;
  historyForm.verificationCode = "";
  rememberDiagnosisPhone(phone);
  bumpPhoneVerifyTick();
  // 优先展示该号已缓存的历史列表与分页（查询其他号时保留的记录）
  const cached = getHistoryMapEntry(phone);
  if (cached && Array.isArray(cached.list)) {
    applyHistoryFromCache({ ...cached, phone });
    writeHistoryCache(phone, cached.list);
    return;
  }
  if (hasValidDiagnosisVerifyToken(phone)) {
    queryHistory();
  }
};

const restoreGuestVerifyState = () => {
  if (isLoggedIn.value) return;
  // const phone =
  //   getLastDiagnosisVerifiedPhone() || getRememberedDiagnosisPhone();
  // if (phone && (!formData.form.phone || isMaskedPhone(formData.form.phone))) {
  //   formData.form.phone = phone;
  // }
  // if (hasValidDiagnosisVerifyToken(formData.form.phone || phone)) {
  //   forceSmsVerify.value = false;
  //   // const p = formData.form.phone || phone;
  //   // const profile = getDiagnosisProfile(p);
  //   // if (profile) {
  //   //   applyProfileToForm(profile);
  //   //   echoedProfilePhone = p;
  //   // }
  // }
  bumpPhoneVerifyTick();
  clearSurveyFormValidate();
};

const clearSurveyFormValidate = async () => {
  await nextTick();
  formRef.value?.clearValidate?.();
};

/**
 * 规则对象保持稳定，避免查历史/切换 needSmsVerify 时整表误校验冒红。
 * 验证码是否必填在 validator 内判断。
 */
const formRules = {
  userName: [
    { required: true, message: "请输入姓名", trigger: "blur" },
    { min: 2, max: 20, message: "姓名长度在 2 到 20之间", trigger: "blur" },
  ],
  phone: [
    {
      required: true,
      validator: validatePhone,
      trigger: "blur",
    },
  ],
  verificationCode: [
    {
      validator: (_rule, value, callback) => {
        if (!needSmsVerify.value) {
          callback();
          return;
        }
        const code = String(value || "").trim();
        if (!code) {
          callback(new Error("请输入短信验证码"));
          return;
        }
        if (code.length < 4 || code.length > 6) {
          callback(new Error("请输入正确的验证码"));
          return;
        }
        callback();
      },
      trigger: "blur",
    },
  ],
  sex: [{ required: true, message: "请输入性别", trigger: "change" }],
  targetCollege: [{ required: true, message: "请选择或输入目标报考院校", trigger: "change" }],
  undergraduateGradTime: [{ required: true, message: "请选择本科毕业时间", trigger: "change" }],
  undergraduateMajor: [
    { required: true, message: "请输入本科所学专业", trigger: "blur" },
    { min: 2, max: 50, message: "专业长度在 2 到 50 之间", trigger: "blur" },
  ],
  cetLevel: [
    { required: true, message: "请选择英语四六级情况", trigger: "change" },
    {
      validator: (_rule, _value, callback) => {
        if (formData.form.cetLevel === "其他" && !cetLevelOtherText.value.trim()) {
          callback(new Error("请填写其他英语四、六级情况"));
          return;
        }
        callback();
      },
      trigger: "blur",
    },
  ],
};

useHead({
  title: computed(() => `申硕基点诊断-${cookieData.shopName}`),
  meta: [
    {
      hid: "keywords",
      name: "keywords",
      content: "申硕基点诊断",
    },
    {
      hid: "description",
      name: "description",
      content: "申硕基点诊断",
    },
  ],
});

const smsTimerMap = {
  survey: null,
  history: null,
};

const smsCooldownStorageKey = (scene) =>
  scene === "history" ? `${SMS_COOLDOWN_KEY}_history` : SMS_COOLDOWN_KEY;

const clearSmsTimer = (scene = "survey") => {
  if (smsTimerMap[scene]) {
    clearInterval(smsTimerMap[scene]);
    smsTimerMap[scene] = null;
  }
};

const persistSmsCooldown = (scene, endAt) => {
  if (!process.client) return;
  window.sessionStorage.setItem(
    smsCooldownStorageKey(scene),
    JSON.stringify({ endAt })
  );
};

const clearSmsCooldownPersist = (scene) => {
  if (!process.client) return;
  window.sessionStorage.removeItem(smsCooldownStorageKey(scene));
};

const applySmsCooldownUi = (scene, remainSec) => {
  const text = `${remainSec}s`;
  if (scene === "history") {
    historySmsDisabled.value = true;
    historySmsTxt.value = text;
  } else {
    smsDisabled.value = true;
    smsTxt.value = text;
  }
};

const finishSmsCooldown = (scene) => {
  clearSmsTimer(scene);
  clearSmsCooldownPersist(scene);
  if (scene === "history") {
    historySmsDisabled.value = false;
    historySmsTxt.value = "重新获取";
  } else {
    smsDisabled.value = false;
    smsTxt.value = "重新获取";
  }
};

/** 开始/恢复短信倒计时；返回首页后仍按剩余秒数续倒计时 */
const timeOut = (scene = "survey", remainSec = SMS_COOLDOWN_SEC) => {
  clearSmsTimer(scene);
  let num = Math.max(1, Math.ceil(remainSec));
  const endAt = Date.now() + num * 1000;
  persistSmsCooldown(scene, endAt);
  applySmsCooldownUi(scene, num);
  smsTimerMap[scene] = setInterval(() => {
    num -= 1;
    if (num <= 0) {
      finishSmsCooldown(scene);
    } else {
      applySmsCooldownUi(scene, num);
    }
  }, 1000);
};

const restoreSmsCooldown = (scene = "survey") => {
  if (!process.client) return;
  try {
    const raw = window.sessionStorage.getItem(smsCooldownStorageKey(scene));
    if (!raw) return;
    const data = JSON.parse(raw);
    const endAt = Number(data?.endAt || 0);
    const remain = Math.ceil((endAt - Date.now()) / 1000);
    if (remain > 0) {
      timeOut(scene, remain);
    } else {
      clearSmsCooldownPersist(scene);
    }
  } catch (e) {
    clearSmsCooldownPersist(scene);
  }
};

const getCode = async (scene = "survey") => {
  smsScene.value = scene;
  const disabled = scene === "history" ? historySmsDisabled.value : smsDisabled.value;
  if (disabled) return;
  const phone =
    scene === "history"
      ? String(historyForm.phone || "").trim()
      : String(formData.form.phone || "").trim();
  if (!/^1\d{10}$/.test(phone)) {
    ElMessage.error("请输入正确的11位手机号");
    return;
  }
  try {
    const appKeyRes = await getAppKeyInfo({});
    captchaConfig.captchaId = JSON.parse(appKeyRes).captchaId || "";
    if (captchaConfig.captchaId) {
      // 二次打开时先关掉再开，确保 captcha watch 能再次触发
      if (captchaVisible.value) {
        captchaVisible.value = false;
        await nextTick();
      }
      captchaVisible.value = true;
    } else {
      ElMessage.warning("验证码配置为空，无法验证");
    }
  } catch (apiErr) {
    console.error("获取captchaId失败:", apiErr);
    ElMessage.error(apiErr.message || "验证码获取失败，请重试");
  }
};

const handleCaptchaSuccess = async (data) => {
  captchaValidate = data?.validate;
  if (!captchaValidate) {
    ElMessage.error("人机验证失败，请重试");
    return;
  }
  const phone =
    smsScene.value === "history"
      ? historyForm.phone
      : formData.form.phone;
  // 先进入倒计时，避免发送成功后 UI 未锁定导致连点
  timeOut(smsScene.value);
  try {
    await getMsg({
      phone,
      telCode: "86",
      verificationCodeType: 7,
      graphicsType: 1,
      lotNumber: captchaValidate.lot_number,
      passToken: captchaValidate.pass_token,
      genTime: captchaValidate.gen_time,
      captchaOutput: captchaValidate.captcha_output,
    });
    ElMessage.success("验证码已发送");
  } catch (e) {
    console.error("发送短信验证码失败:", e);
    // 发送失败则解除倒计时，允许重试（后端限流错误仍保持倒计时防刷）
    const msg = String((e && (e.message || e.msg)) || "");
    if (!/频繁|过快|稍后|too\s*frequent/i.test(msg)) {
      finishSmsCooldown(smsScene.value);
      if (smsScene.value === "history") {
        historySmsTxt.value = "获取验证码";
      } else {
        smsTxt.value = "获取验证码";
      }
    }
  }
};

const handleCaptchaError = (error) => {
  console.error("验证码错误:", error);
  ElMessage.error(error.message || "验证失败");
};

const handleCaptchaClose = () => {};

const formatHistoryTime = (val) => {
  if (!val) return "";
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return String(val);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const maskPhoneDisplay = (phone) => {
  const p = String(phone || "");
  if (p.length < 7) return p;
  return `${p.slice(0, 3)}****${p.slice(-4)}`;
};

const applyHistoryFromCache = (data) => {
  if (!data) return;
  historyList.value = data.list || [];
  historyPagination.pageCurrent = Number(data.pageCurrent) || 1;
  historyPagination.pageSize = Number(data.pageSize) || 10;
  const listLen = Array.isArray(data.list) ? data.list.length : 0;
  historyPagination.totalCount =
    data.totalCount != null ? Number(data.totalCount) || 0 : listLen;
  historyPagination.totalPage =
    data.totalPage != null
      ? Number(data.totalPage) || 0
      : Math.ceil(historyPagination.totalCount / historyPagination.pageSize);
  historyQueried.value = true;
};

const buildHistoryCacheEntry = (phone, list) => {
  const p = String(phone || "").trim();
  const view = isLoggedIn.value
    ? userStore.userView || userStore.getLocalSession("userInfo") || {}
    : {};
  return {
    phone: p,
    list: list || [],
    pageCurrent: historyPagination.pageCurrent,
    pageSize: historyPagination.pageSize,
    totalCount: historyPagination.totalCount,
    totalPage: historyPagination.totalPage,
    loggedIn: isLoggedIn.value,
    uid: isLoggedIn.value ? String(view.id || view.userId || "") : "",
    expireAt: Date.now() + HISTORY_CACHE_TTL,
  };
};

const readHistoryCache = () => {
  try {
    if (!process.client) return null;
    const raw = window.sessionStorage.getItem(HISTORY_CACHE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.expireAt || Date.now() > data.expireAt) {
      window.sessionStorage.removeItem(HISTORY_CACHE_KEY);
      return null;
    }
    // 登录态与游客缓存隔离，避免串数据
    if (!!data.loggedIn !== isLoggedIn.value) {
      return null;
    }
    // 登录态再按用户身份隔离，避免切换账号后展示上一用户的记录
    if (isLoggedIn.value) {
      const view = userStore.userView || userStore.getLocalSession("userInfo") || {};
      const uid = String(view.id || view.userId || "");
      if (!uid || !data.uid || data.uid !== uid) {
        return null;
      }
    }
    // 游客：没有有效 verifyToken 时丢弃列表缓存，避免“已查过历史但调查表仍要验证码”
    if (
      !isLoggedIn.value &&
      data.phone &&
      !hasValidDiagnosisVerifyToken(data.phone)
    ) {
      window.sessionStorage.removeItem(HISTORY_CACHE_KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
};

const writeHistoryCache = (phone, list) => {
  if (!process.client) return;
  const entry = buildHistoryCacheEntry(phone, list);
  window.sessionStorage.setItem(HISTORY_CACHE_KEY, JSON.stringify(entry));
  // 按手机号保留多份列表与分页，查询其他号时不丢之前的记录
  if (/^1\d{10}$/.test(entry.phone)) {
    writeHistoryMapEntry(entry.phone, entry);
  }
};

const readHistoryMap = () => {
  try {
    if (!process.client) return {};
    const raw = window.sessionStorage.getItem(HISTORY_MAP_KEY);
    if (!raw) return {};
    const data = JSON.parse(raw);
    return data && typeof data === "object" ? data : {};
  } catch (e) {
    return {};
  }
};

const writeHistoryMapEntry = (phone, payload) => {
  if (!process.client) return;
  const p = String(phone || "").trim();
  if (!/^1\d{10}$/.test(p)) return;
  const entry =
    payload && typeof payload === "object" && !Array.isArray(payload)
      ? { ...payload, phone: p, expireAt: Date.now() + HISTORY_CACHE_TTL }
      : buildHistoryCacheEntry(p, payload || []);
  const map = readHistoryMap();
  map[p] = entry;
  window.sessionStorage.setItem(HISTORY_MAP_KEY, JSON.stringify(map));
};

const getHistoryMapEntry = (phone) => {
  const p = String(phone || "").trim();
  const entry = readHistoryMap()[p];
  if (!entry || !entry.expireAt || Date.now() > entry.expireAt) {
    return null;
  }
  return entry;
};

const clearHistoryCache = () => {
  if (!process.client) return;
  window.sessionStorage.removeItem(HISTORY_CACHE_KEY);
};

const resetHistoryQuery = () => {
  // 仅切换到「查其他号」：保留当前号列表与分页缓存、verifyToken，不清凭证
  const phone = String(historyForm.phone || "").trim();
  if (phone && historyQueried.value) {
    writeHistoryMapEntry(phone, buildHistoryCacheEntry(phone, historyList.value));
  }
  historyQueried.value = false;
  historyList.value = [];
  historyPagination.pageCurrent = 1;
  historyPagination.totalCount = 0;
  historyPagination.totalPage = 0;
  historyForm.phone = "";
  historyForm.verificationCode = "";
  historyErrorMsg.value = "";
  bumpPhoneVerifyTick();
};

const openHistoryDialog = () => {
  historyForm.verificationCode = "";
  historyErrorMsg.value = "";
  const cache = readHistoryCache();
  if (cache) {
    applyHistoryFromCache(cache);
    if (cache.phone) {
      historyForm.phone = cache.phone;
    }
  } else {
    historyList.value = [];
    historyQueried.value = false;
    if (!historyForm.phone) {
      const view = userStore.userView || userStore.getLocalSession("userInfo") || {};
      if (view.phone && !isMaskedPhone(view.phone)) {
        historyForm.phone = view.phone;
      } else if (formData.form.phone && !isMaskedPhone(formData.form.phone)) {
        historyForm.phone = formData.form.phone;
      }
    }
    bumpPhoneVerifyTick();
    // 已登录或本地有有效 verifyToken：直接进入加载，避免闪出短信表单
    if (isLoggedIn.value || hasValidDiagnosisVerifyToken(historyForm.phone)) {
      historyLoading.value = true;
    }
  }
  historyVisible.value = true;
};

const onHistoryOpened = () => {
  // 已有缓存结果时不再自动请求
  if (historyQueried.value) {
    return;
  }
  if (isLoggedIn.value) {
    queryHistory({ preferLogin: true });
    return;
  }
  // 游客已有 verifyToken：免码直接查
  if (hasValidDiagnosisVerifyToken(historyForm.phone)) {
    queryHistory();
  }
};

/** 关闭历史弹窗后再同步手机号到调查表，并清掉可能残留的红字 */
const onHistoryClosed = async () => {
  const phone = String(historyForm.phone || "").trim();
  if (!isLoggedIn.value && /^1\d{10}$/.test(phone)) {
    rememberDiagnosisPhone(phone);
    if (!formData.form.phone || isMaskedPhone(formData.form.phone)) {
      formData.form.phone = phone;
    }
    if (hasValidDiagnosisVerifyToken(phone)) {
      forceSmsVerify.value = false;
    }
    bumpPhoneVerifyTick();
  }
  await clearSurveyFormValidate();
};

const refreshHistoryLogin = () => {
  clearHistoryCache();
  historyQueried.value = false;
  historyList.value = [];
  historyErrorMsg.value = "";
  historyPagination.pageCurrent = 1;
  historyLoading.value = true;
  queryHistory({ preferLogin: true });
};

const onHistoryPageChange = (page) => {
  historyPagination.pageCurrent = page;
  queryHistory({ keepPage: true });
};

const queryHistory = async (options = {}) => {
  const preferLogin = !!options.preferLogin || isLoggedIn.value;
  if (!options.keepPage) {
    historyPagination.pageCurrent = 1;
  }
  const phone = String(historyForm.phone || "").trim();
  const code = String(historyForm.verificationCode || "").trim();
  const localToken = getDiagnosisVerifyToken(phone);
  historyErrorMsg.value = "";

  // 游客：有 verifyToken 免码；否则须手机号+验证码
  if (!isLoggedIn.value) {
    if (!/^1\d{10}$/.test(phone)) {
      ElMessage.error("请输入正确的11位手机号");
      return;
    }
    if (!localToken && !code) {
      ElMessage.error("请输入短信验证码");
      return;
    }
  }

  historyLoading.value = true;
  try {
    const payload = {};
    if (!isLoggedIn.value) {
      payload.phone = phone;
      payload.telCode = "86";
      if (localToken) {
        payload.verifyToken = localToken.token;
      } else {
        payload.verificationCode = code;
      }
    } else {
      // 登录态查询失败时不弹通用错误打断（自行展示重试）
      payload.isShowErrTip = false;
    }
    payload.pageCurrent = historyPagination.pageCurrent;
    payload.pageSize = historyPagination.pageSize;
    const res = await diagnosisReportHistory(payload);
    historyList.value = (res && res.list) || [];
    historyPagination.totalCount = Number(res?.totalCount) || 0;
    historyPagination.totalPage = Number(res?.totalPage) || 0;
    historyPagination.pageCurrent = Number(res?.pageCurrent) || historyPagination.pageCurrent;
    historyPagination.pageSize = Number(res?.pageSize) || historyPagination.pageSize;
    historyQueried.value = true;
    if (res && res.verifyToken && phone) {
      // 只存凭证，查历史过程中不改调查表，避免背景表单误校验冒红
      saveDiagnosisVerifyToken(phone, res.verifyToken, res.expireTime);
      rememberDiagnosisPhone(phone);
      forceSmsVerify.value = false;
      bumpPhoneVerifyTick();
    } else if (!isLoggedIn.value && phone) {
      rememberDiagnosisPhone(phone);
      console.warn(
        "[diagnosis] report/history 响应=",
        res,
        "未包含 verifyToken。请确认 resource 已用最新代码重启。"
      );
      ElMessage.warning(
        "未获取到免验凭证：请重启 resource 服务后再「重新验证查询」一次"
      );
    }
    writeHistoryCache(phone || historyForm.phone, historyList.value);
    if (!historyList.value.length) {
      ElMessage.info("暂无诊断记录");
    }
  } catch (e) {
    console.error(e);
    const msg =
      (e && (e.message || e.msg)) ||
      (preferLogin ? "查询失败，请稍后重试" : "查询失败");
    if (!isLoggedIn.value && isDiagnosisVerifyExpiredMsg(msg)) {
      clearDiagnosisVerifyToken(phone);
      bumpPhoneVerifyTick();
    }
    if (isLoggedIn.value) {
      historyQueried.value = false;
      historyList.value = [];
      historyErrorMsg.value = msg;
    } else {
      historyQueried.value = false;
      ElMessage.error(msg);
    }
  } finally {
    historyLoading.value = false;
  }
};

const goHistoryReport = (item) => {
  if (!item?.recordId || item.ready === false) {
    return;
  }
  const url = `/entrancetest/report?recordId=${item.recordId}`;
  window.open(url, "_blank");
};

const loadSubjectView = async (subjectId) => {
  const res = await diagnosisEntranceView({ subjectId });
  if (res) {
    formData.map = {
      paperId: res.paperId,
      title: res.entranceTestName,
      description: res.description || "",
    };
  }
};

const handleSelectSubject = async (item) => {
  selectedSubjectId.value = item.id;
  await loadSubjectView(item.id);
};

const loadSubjectList = async () => {
  const list = await diagnosisSubjectList();
  subjectList.value = list || [];
  if (subjectList.value.length) {
    await handleSelectSubject(subjectList.value[0]);
  }
};

const loadCollegeList = async () => {
  try {
    const list = await diagnosisCollegeList();
    cooperativeColleges.value = (list || [])
      .map((item) => item?.collegeName || item)
      .filter(Boolean);
  } catch (e) {
    console.error(e);
    cooperativeColleges.value = [];
  }
};

/**
 * 清理「仅 cookie 残留、pinia 已无登录态」的失效 token，
 * 避免请求头仍带 token、后端按游客要验证码，而 UI 曾误判为已登录。
 */
const syncGuestTokenState = () => {
  if (!process.client) return;
  const cookieToken = userStore.getToken();
  if (cookieToken && !userStore.token) {
    cookie.delInClient(config.tokenName);
  }
};

/** 已登录预填；游客回填最近手机号，有凭证则免验证码 */
const prefillLoggedInUser = async () => {
  if (isLoggedIn.value) {
    let view = userStore.userView || userStore.getLocalSession("userInfo") || {};
    if (!view.id && !view.userId) {
      // 新标签页/刷新后 pinia 与 sessionStorage 可能都为空，主动拉一次
      view = (await userStore.getUserView().catch(() => null)) || {};
    }
    const profile = getDiagnosisUserProfile(String(view.id || view.userId || ""), view.phone);
    if (profile) {
      applyProfileToForm(profile); // 上次提交的档案优先于昵称预填
    }
    if (!formData.form.userName && view.nickname) {
      formData.form.userName = view.nickname;
    }
    if (!formData.form.phone && view.phone) {
      formData.form.phone = view.phone;
    }
    return;
  }
  restoreGuestVerifyState();
};

watch(surveyPhone, (phone) => {
  if (isLoggedIn.value) return;
  if (hasValidDiagnosisVerifyToken(phone)) {
    forceSmsVerify.value = false;
    bumpPhoneVerifyTick();
    if (phone !== echoedProfilePhone) {
      // 表单处于「旧号码回显态」：换号 = 先清掉旧号码回显的内容，再整体回显新号码
      // 表单处于「用户手填态」（echoedProfilePhone 为空）：不动已填内容，只补空字段
      if (echoedProfilePhone) {
        resetProfileForm();
        formData.form.verificationCode = "";
        echoedProfilePhone = "";
        clearSurveyFormValidate();
      }
      const profile = getDiagnosisProfile(phone);
      if (profile) {
        applyProfileToForm(profile); // reset 后字段全空 → 整体回显新号；手填态 → 只补空字段
        echoedProfilePhone = phone;
      }
    }
    return;
  }
  // 删除手机号/改成未验证号码：清掉上一手机号回显的档案
  if (echoedProfilePhone) {
    resetProfileForm();
    formData.form.verificationCode = "";
    echoedProfilePhone = "";
    clearSurveyFormValidate();
  }
});

watch(historyPhone, (phone) => {
  if (!isLoggedIn.value && hasValidDiagnosisVerifyToken(phone)) {
    bumpPhoneVerifyTick();
  }
});

const submitForm = () => {
  if (!selectedSubjectId.value) {
    ElMessage.warning("请先选择学科");
    return;
  }
  formRef.value.validate(async (valid) => {
    if (!valid) {
      return;
    }
    const phone = String(formData.form.phone || "").trim();
    const localToken = getDiagnosisVerifyToken(phone);

    // 四六级：选「其他」时用输入内容替换「其他」（校验已保证非空）
    const cetLevelValue =
      formData.form.cetLevel === "其他"
        ? cetLevelOtherText.value.trim()
        : formData.form.cetLevel;

    // 备考难题：选「其他」且有输入 → 用内容替换「其他」；无输入 → 保留「其他」
    let prepDifficultiesValue = Array.isArray(formData.form.prepDifficulties)
      ? [...formData.form.prepDifficulties]
      : [];
    if (prepDifficultiesValue.includes("其他")) {
      const t = prepDifficultyOtherText.value.trim();
      prepDifficultiesValue = prepDifficultiesValue.filter((x) => x !== "其他");
      prepDifficultiesValue.push(t || "其他");
    }

    const payload = {
      subjectId: selectedSubjectId.value,
      userName: formData.form.userName,
      phone: formData.form.phone,
      telCode: "86",
      sex: formData.form.sex,
      ageGroup: formData.form.ageGroup,
      targetCollege: formData.form.targetCollege,
      undergraduateGradTime: formData.form.undergraduateGradTime,
      undergraduateMajor: formData.form.undergraduateMajor,
      cetLevel: cetLevelValue,
      currentJob: formData.form.currentJob || undefined,
      prepDifficulties: prepDifficultiesValue.length ? prepDifficultiesValue : undefined,
      prepDuration: formData.form.prepDuration || undefined,
    };
    if (!isLoggedIn.value) {
      if (localToken) {
        payload.verifyToken = localToken.token;
      } else if (needSmsVerify.value && formData.form.verificationCode) {
        payload.verificationCode = formData.form.verificationCode;
      } else {
        forceSmsVerify.value = true;
        bumpPhoneVerifyTick();
        ElMessage.warning("请先获取并输入短信验证码后再提交");
        return;
      }
    }
    try {
      const saveRes = await diagnosisUserSave(payload);
      const entranceTestUserId =
        saveRes && typeof saveRes === "object"
          ? saveRes.entranceTestUserId
          : saveRes;
      if (!entranceTestUserId) {
        return;
      }
      // 无论是否免验，都记住手机号，返回首页可回填
      rememberDiagnosisPhone(phone);
      // 验证通过：按身份保存档案到本地（verifyToken 仍只由 saveDiagnosisVerifyToken 维护）
      const profileToSave = {
        ...collectProfileForm(),
        cetLevel: cetLevelValue,
        prepDifficulties: prepDifficultiesValue,
      };
      if (isLoggedIn.value) {
        const view = userStore.userView || userStore.getLocalSession("userInfo") || {};
        saveDiagnosisUserProfile(String(view.id || view.userId || ""), view.phone, profileToSave);
      } else {
        saveDiagnosisProfile(phone, profileToSave);
      }
      if (saveRes && typeof saveRes === "object" && saveRes.verifyToken && phone) {
        saveDiagnosisVerifyToken(phone, saveRes.verifyToken, saveRes.expireTime);
        forceSmsVerify.value = false;
        bumpPhoneVerifyTick();
      } else if (!isLoggedIn.value && payload.verificationCode) {
        console.warn(
          "[diagnosis] user/save 未返回 verifyToken，返回首页后仍可能要短信。响应=",
          saveRes
        );
      }
      router.push({
        path: "/entrancetest/exam",
        query: {
          paperId: formData.map.paperId,
          entranceTestUserId,
          formDataName: formData.map.title,
          subjectId: selectedSubjectId.value,
          diagnosis: "1",
        },
      });
    } catch (e) {
      const msg = (e && (e.message || e.msg)) || "";
      // 凭证失效，或后端仍按旧逻辑只认短信码
      if (!isLoggedIn.value && isDiagnosisVerifyExpiredMsg(msg)) {
        clearDiagnosisVerifyToken(phone);
        forceSmsVerify.value = true;
        bumpPhoneVerifyTick();
        if (msg.includes("请输入手机号和短信验证码")) {
          ElMessage.warning(
            "提交未带上有效免验凭证（或后端未支持 verifyToken）。请确认 resource 已重启，并用验证码再提交一次"
          );
        } else {
          ElMessage.warning("请先获取并输入短信验证码后再提交");
        }
      } else if (
        isLoggedIn.value &&
        !needSmsVerify.value &&
        isDiagnosisVerifyExpiredMsg(msg)
      ) {
        forceSmsVerify.value = true;
        userStore.removeToken();
        ElMessage.warning("请先获取并输入短信验证码后再提交");
      }
    }
  });
};

onMounted(() => {
  syncGuestTokenState();
  prefillLoggedInUser();
  restoreSmsCooldown("survey");
  restoreSmsCooldown("history");
  loadSubjectList();
  loadCollegeList();
  if (process.client) {
    document.addEventListener("click", onCollegeDocClick, true);
  }
});

// keep-alive / 从报告返回首页时再恢复一次凭证态
onActivated(() => {
  syncGuestTokenState();
  restoreGuestVerifyState();
});

onUnmounted(() => {
  clearSmsTimer("survey");
  clearSmsTimer("history");
  if (process.client) {
    document.removeEventListener("click", onCollegeDocClick, true);
  }
});
</script>

<style lang="scss" scoped>
@import "./element-variables.scss";

:deep(.el-divider--horizontal) {
  margin: 0;
}

:deep(.el-divider--vertical) {
  width: 8px;
  height: 1.2em;
  margin: 0 8px 0 0;
  border-left: 3px solid #13b95c;
  margin-bottom: 4px;
}

.sms_btn {
  margin-right: 4px;
  white-space: nowrap;
}

.verified-phone-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.verified-phone-label {
  color: #909399;
  font-size: 12px;
}

.verified-phone-chip {
  border: 1px solid #b3e0c5;
  background: #f0faf4;
  color: #13b95c;
  border-radius: 14px;
  padding: 2px 10px;
  font-size: 12px;
  cursor: pointer;
  line-height: 1.6;
}

.verified-phone-chip:hover {
  background: #e4f6ec;
}

.verify-free-tip {
  margin: 6px 0 0 6px;
  color: #13b95c;
  font-size: 12px;
  line-height: 1.4;
}

:deep(.body-form .el-input__suffix),
:deep(.el-dialog .el-input__suffix) {
  display: flex;
  align-items: center;
}

.history-entry {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;

  :deep(.el-button) {
    color: #13b95c;
    font-size: 14px;

    &:hover,
    &:focus {
      color: #0fa352;
    }
  }
}

.history-verify {
  padding: 4px 8px 8px;
}

.history-verify-tip {
  margin: 0 0 20px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 20px;
  color: #666;
  background: #f6fbf8;
  border: 1px solid #e3f5eb;
  border-radius: 8px;
}

.history-verify-form {
  max-width: 100%;

  :deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 0 0 1px #13b95c inset;
  }
}

.history-code-row {
  display: flex;
  gap: 10px;
  width: 100%;

  .el-input {
    flex: 1;
  }
}

.history-sms-btn {
  flex-shrink: 0;
  min-width: 120px;
  color: #13b95c !important;
  border-color: #13b95c !important;
  background: #fff !important;

  &:hover,
  &:focus {
    color: #fff !important;
    border-color: #13b95c !important;
    background: #13b95c !important;
  }

  &.is-disabled {
    color: #a8d5bd !important;
    border-color: #ccebd9 !important;
    background: #f6fbf8 !important;
  }
}

.history-query-btn {
  width: 100%;
  margin-top: 8px;
  --el-button-bg-color: #13b95c;
  --el-button-border-color: #13b95c;
  --el-button-hover-bg-color: #0fa352;
  --el-button-hover-border-color: #0fa352;
  --el-button-active-bg-color: #0d9148;
  --el-button-active-border-color: #0d9148;
}

.history-result-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  :deep(.el-button) {
    color: #13b95c;

    &:hover,
    &:focus {
      color: #0fa352;
    }
  }
}

.history-result-count {
  font-size: 13px;
  color: #888;
}

.history-list {
  max-height: 420px;
  overflow: auto;
}

.history-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  margin-bottom: 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  :deep(.el-button--primary) {
    --el-button-bg-color: #13b95c;
    --el-button-border-color: #13b95c;
    --el-button-hover-bg-color: #0fa352;
    --el-button-hover-border-color: #0fa352;
    --el-button-active-bg-color: #0d9148;
    --el-button-active-border-color: #0d9148;
    --el-button-disabled-bg-color: #a8d5bd;
    --el-button-disabled-border-color: #a8d5bd;
  }
}

.history-title {
  font-size: 15px;
  font-weight: 600;
  color: #222;
  margin-bottom: 8px;
}

.history-level {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #13b95c;
}

.history-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 13px;
  color: #888;
}

.submit-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.privacy-tip {
  color: #999;
  font-size: 12px;
  line-height: 1.5;
}

.history-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

:deep(.history-pagination .el-pagination.is-background .el-pager li.is-active) {
  background-color: #13b95c;
}

.entrace-body {
  background: #fff;
  padding: 30px 50px 50px;
  margin-top: 15px;
  border-radius: 5px;

  .body-desc {
    margin: 0 0 28px;
    font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
    font-size: 14px;
    color: #666;
    line-height: 26px;
    font-weight: 400;
    white-space: pre-line;
  }

  .section-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    color: #222;

    &.survey-head {
      margin-top: 28px;
    }
  }

  .section-title {
    font-size: 18px;
    line-height: 28px;
    font-weight: 550;
  }

  .section-tip {
    margin-left: 12px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    color: #8b9bb5;
  }

  .subject-tabs {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;

    .search_type_item {
      font-size: 14px;
      color: #333333;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 12px;
      padding: 6px 10px;

      &.active,
      &:hover {
        color: #13b95c;
        font-weight: bold;
        background: rgba(19, 185, 92, 0.08);
        border-radius: 5px;
      }
    }
  }

  .body-form {
    max-width: 600px;
    margin: 32px 0 0;

    :deep(.el-form-item__label) {
      font-size: 14px;
      font-weight: 600;
      color: #333;
    }

    :deep(.college-form-item.is-college-open) {
      position: relative;
      z-index: 30;
    }
  }

  .college-picker {
    position: relative;
    width: 100%;
  }

  .college-picker__list {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(100% + 4px);
    z-index: 40;
    max-height: 280px;
    margin: 0;
    padding: 6px 0;
    list-style: none;
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  .college-picker__item {
    padding: 0 16px;
    line-height: 34px;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background: #f5f7fa;
      color: #13b95c;
    }
  }

  .college-picker__empty {
    padding: 10px 16px;
    font-size: 13px;
    color: #909399;
    line-height: 1.4;
  }

  .other-input {
    margin-top: 8px;
    max-width: 360px;
  }
}
</style>

<style lang="scss">
/* 弹窗可能挂到 body，需非 scoped 才能覆盖入学测试页黑色按钮主题 */
.history-dialog {
  .history-entry-link,
  .history-result-bar .el-button {
    color: #13b95c;

    &:hover,
    &:focus {
      color: #0fa352;
    }
  }

  .history-sms-btn {
    color: #13b95c !important;
    border-color: #13b95c !important;
    background: #fff !important;

    &:hover,
    &:focus {
      color: #fff !important;
      border-color: #13b95c !important;
      background: #13b95c !important;
    }
  }

  .history-query-btn.el-button--primary,
  .history-item .el-button--primary {
    --el-button-bg-color: #13b95c;
    --el-button-border-color: #13b95c;
    --el-button-hover-bg-color: #0fa352;
    --el-button-hover-border-color: #0fa352;
    --el-button-active-bg-color: #0d9148;
    --el-button-active-border-color: #0d9148;
    --el-button-disabled-bg-color: #a8d5bd;
    --el-button-disabled-border-color: #a8d5bd;
    background-color: #13b95c;
    border-color: #13b95c;

    &:hover,
    &:focus {
      background-color: #0fa352;
      border-color: #0fa352;
    }
  }

  .el-input__wrapper.is-focus {
    box-shadow: 0 0 0 1px #13b95c inset !important;
  }
}
</style>
